/**
 * DensityController — Applies data-density attribute to the document root element.
 * Story 13.6: Persona-Adaptive Density System (AC-4)
 *
 * Pure side-effect component (renders null). React manages state,
 * CSS custom properties do the styling via [data-density] selectors.
 */

import { useEffect } from "react";
import { usePersonaContext } from "@/shared/context/persona-provider";

function DensityController() {
  const { density } = usePersonaContext();

  useEffect(() => {
    document.documentElement.setAttribute("data-density", density);
    return () => {
      document.documentElement.removeAttribute("data-density");
    };
  }, [density]);

  return null;
}

export { DensityController };
